export default "__VITE_ASSET__Bicf0A93__"